import StatusInfoCell from '../components/StatusInfoCell';
import TableActions from '../components/TableActions';

export const DEFAULT_COLUMNS = [
  { field: 'id', maxWidth: 100 },
  { field: 'title' },
  { field: 'description' },
  { field: 'duration_seconds', headerName: 'Duration (s)' },
  {
    field: 'is_active',
    headerName: 'Status',
    cellRenderer: ({ value }) => <StatusInfoCell status={value} />
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: (params) => {
      return <TableActions {...params} />;
    },
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];
